module.exports = __webpack_public_path__ + "static/img/3.c48c4d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/3.jpg
// module id = Wzr1
// module chunks = 15